<div class="row w-100 d-flex p-1 align-items-center">
    <div class="col-6 firstcol text-truncate">{{workgroupMember.user.firstName}} {{workgroupMember.user.prefix}} {{workgroupMember.user.lastName}}</div>
    <div class="col-3">
        <div ngbDropdown class="col-12 dropdown w-50" *ngIf="usingClearancelevel">
            <button class="btn btn-sm default dropdown-toggle text-truncate" type="button" id="dropdownMenu" ngbDropdownToggle>
                {{ workgroupMember.clearanceLevel ? workgroupMember.clearanceLevel : 1 }}
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
            </button>
            
            <div ngbDropdownMenu aria-labelledby="dropdownMenu" >
                <button class="action" *ngFor="let clearanceLevel of clearancelevels" (click)="changeCurrentClearancelevel(clearanceLevel)" ngbDropdownItem>{{clearanceLevel}}</button>
            </div>
        </div>
    </div>
    <div class="col-3 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Delete" (click)="deleteMember()"></a></li>
            </ul>
        </div>
    </div>
</div>